import { ValidationObserver, ValidationProvider } from "vee-validate";
import Qrcode from "v-qrcode/src/index.vue";

export default {
  name: "AssignDeviceDialog",
  components: {
    Qrcode,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    residentId: {
      type: String,
      default: () => null
    },
  },
  data() {
    return {
      dialog: true
    }
  },
  computed: {
    qrCode(): string {
      return `${this.residentId}@reshub.ie|${this.currentFacility}${this.residentId}`;
    },
    user() {
      return this.$store.state.authModule.user
    },
    currentFacility() {
      return this.$store.state.authModule.currentFacility;
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false;
    }
  }
}